import { useCallback } from 'react'
import { useLocalStorage } from '@/hooks/useLocalStorage'
import { useAppSelector } from '@/redux/rootReducer'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'

const FAVORITES_KEY = 'wr_favorites'
const LAST_SELECTED_KEY = 'wr_last_selected'

function userKey(userId: string | undefined, base: string) {
  return userId ? `${base}_${userId}` : base
}

export function useWaitingRoomPreferences() {
  const authUser = useAppSelector(selectAuthUser)
  const userId = authUser?._id

  const [favoriteIds, setFavoriteIds] = useLocalStorage<string[]>(
    userKey(userId, FAVORITES_KEY),
    []
  )

  const [lastSelectedId, setLastSelectedId] = useLocalStorage<string | null>(
    userKey(userId, LAST_SELECTED_KEY),
    null
  )

  const toggleFavorite = useCallback(
    (id: string) => {
      setFavoriteIds((prev) =>
        prev.includes(id) ? prev.filter((fId) => fId !== id) : [...prev, id]
      )
    },
    [setFavoriteIds]
  )

  const isFavorite = useCallback(
    (id: string) => favoriteIds.includes(id),
    [favoriteIds]
  )

  const saveLastSelected = useCallback(
    (id: string) => setLastSelectedId(id),
    [setLastSelectedId]
  )

  return {
    favoriteIds,
    lastSelectedId,
    toggleFavorite,
    isFavorite,
    saveLastSelected,
  }
}
